var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0837 6.3665C17.0837 3.00817 16.3003 2.1665 13.1503 2.1665H6.85033C3.70033 2.1665 2.91699 3.00817 2.91699 6.3665V15.7498C2.91699 17.9665 4.13366 18.4915 5.60866 16.9082L5.61699 16.8998C6.30033 16.1748 7.34199 16.2332 7.93366 17.0248L8.77533 18.1498C9.45033 19.0415 10.542 19.0415 11.217 18.1498L12.0587 17.0248C12.6587 16.2248 13.7003 16.1665 14.3837 16.8998C15.867 18.4832 17.0753 17.9582 17.0753 15.7415V9.6665",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 6.3335H13.3337",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.6665H12.5",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrail);
export default __webpack_public_path__ + "static/media/auditTrail.d9e5e2d7e28d8f8c302327d545dc70c7.svg";
export { ForwardRef as ReactComponent };